import { GET_DECLARATION_STATUS_FAILURE, GET_DECLARATION_STATUS_REQUEST, GET_DECLARATION_STATUS_RESET, GET_DECLARATION_STATUS_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const getDeclarationStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DECLARATION_STATUS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, data: null });
        case GET_DECLARATION_STATUS_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case GET_DECLARATION_STATUS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, data: null });
        case GET_DECLARATION_STATUS_RESET:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
export default getDeclarationStatusReducer;
